module.exports = __webpack_public_path__ + "img/individual-meter-electricity-meter-digital-sm.f6080ed9.svg";